import { render, staticRenderFns } from "./ConstitutionAnalysis.vue?vue&type=template&id=140cb40f&scoped=true&"
import script from "./ConstitutionAnalysis.vue?vue&type=script&lang=js&"
export * from "./ConstitutionAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ConstitutionAnalysis.vue?vue&type=style&index=0&id=140cb40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140cb40f",
  null
  
)

export default component.exports